import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//Styles
import { useStyles } from 'components/sheets/AccountManageModuleSheets/AccountManageSheets.style';
//Mui components
import {
    Collapse,
    FormControl,
    IconButton,
    InputLabel,
    Select,
    Switch,
    TextField,
    Dialog,
    Tooltip
} from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuIcon from '@mui/icons-material/Menu';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
//Drag and Drop Lib
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
//Color picker
import { SketchPicker } from 'react-color';
//Locales
import translate from 'locales/i18n';
import Facade from 'core/Facade';
import AlertAction from 'actions/AlertAction';

const ManageSliderSheet = ({
    activeModule,
    config,
    setActiveModule,
    setConfig,
    sites
}) => {

    const classes = useStyles();

    const [showSites, setShowSites] = useState(true);
    const [dialogColorPicker, setDialogColorPicker] = useState(false);

    const [selectedSite, setSelectedSite] = useState(null);

    useEffect(() => {
        if (selectedSite) setDialogColorPicker(true);
    }, [selectedSite]);

    const addSite = (siteId) => {
        if (config.sites.find(s => s.id === siteId)) {
            AlertAction.open('error', 'Le site est déjà sélctionné', 'top-right');
            return;
        }
        const newConfig = Object.assign({}, config);
        newConfig.sites.push({
            id: siteId,
            name: Facade.siteDisplayName(sites.find(s => s.id === siteId).name),
            color: sites.find(s => s.id === siteId).color
        });
        setConfig(newConfig);
    };

    const deleteSite = (siteId) => {
        const newConfig = Object.assign({}, config);
        const newSites = newConfig.sites.filter(site => site.id !== siteId);
        newConfig.sites = newSites;
        setConfig(newConfig);
    };

    const resetSite = (siteId) => {
        const newConfig = Object.assign({}, config);
        const newSites = newConfig.sites.map(site => {
            if (site.id === siteId) {
                return {
                    id: siteId,
                    name: Facade.siteDisplayName(sites.find(s => s.id === siteId).name),
                    color: sites.find(s => s.id === siteId).color
                };
            }
            return site;
        });
        newConfig.sites = newSites;
        setConfig(newConfig);
    };

    const sitesOnDragEnd = (result) => {
        if (!result.destination) return;
        const newConfig = Object.assign({}, config);
        const [removed] = newConfig.sites.splice(result.source.index,1);
        newConfig.sites.splice(result.destination.index,0,removed);
        setConfig(newConfig);
    };

    const handleChangeSite = (siteId, field, value) => {
        const newConfig = Object.assign({}, config);
        const site = newConfig.sites.find(s => s.id === siteId);
        site[field] = value;
        setConfig(newConfig);
    };

    const renderDialogColorPicker = () => <Dialog open={dialogColorPicker} onClose={() => {
        setDialogColorPicker(false);
        setSelectedSite(null);
    }}>
        {selectedSite && <SketchPicker
            onChangeComplete={newColor => handleChangeSite(selectedSite.id, 'color', newColor.hex)}
            color={selectedSite.color}
            disableAlpha
            label={translate.i18n('COLOR')} />}
    </Dialog>;

    return <div className={classes.moduleManageContainer}>
        <div className={classes.activeModule}>
            <div className={classes.titleText}>
                Activer le module Slider pour le compte
            </div>
            <Switch checked={activeModule} onChange={() => setActiveModule(!activeModule)} />
        </div>
        <div className={classes.activeModule}>
            <div className={classes.titleText}>
                Configuration des sites
            </div>
            <IconButton onClick={() => setShowSites(!showSites)}>
                {showSites ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
        </div>
        <Collapse in={showSites} className={classes.configContainer}>
            <div>
                <div className={classes.activeModule}>
                    <div className={classes.text}>
                        Ajouter un site
                    </div>
                    <FormControl variant='outlined'
                        className={classes.moduleSiteSelect}
                    >
                        <InputLabel
                            htmlFor='outlined'
                            size='small'
                            margin={'dense'}>
                            Sites
                        </InputLabel>
                        <Select
                            native
                            value={''}
                            size='small'
                            onChange={event => addSite(event.target.value)}
                            label='Sites'
                        >
                            <option aria-label='None' value={''}></option>
                            {sites.map(s => s.sliderConfig ? <option value={s.id} key={s.id}>{s.name}</option> : null)}
                        </Select>
                    </FormControl>
                </div>
                <DragDropContext onDragEnd={sitesOnDragEnd}>
                    <Droppable droppableId='droppable'>
                        {(provided) =>
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {config.sites.map((site,index) =>
                                    <Draggable key={site.id} draggableId={site.id} index={index}>
                                        {(dragProvided) =>
                                            <div
                                                ref={dragProvided.innerRef}
                                                {...dragProvided.draggableProps}
                                                {...dragProvided.dragHandleProps}
                                                className={classes.draggableSite}>
                                                <MenuIcon />
                                                <div className={classes.siteName}>
                                                    {sites.find(s => s.id === site.id).name}
                                                </div>
                                                <TextField
                                                    label='Display name'
                                                    value={site.name}
                                                    variant='outlined'
                                                    size='small'
                                                    onChange={event => handleChangeSite(site.id, 'name', event.target.value)}
                                                />
                                                <IconButton onClick={() => setSelectedSite(site)} className={classes.configIcon}>
                                                    <FormatColorFillIcon style={{ color: site.color }}/>
                                                </IconButton>
                                                <Tooltip title='Params par défaut' disableInteractive>
                                                    <IconButton onClick={() => resetSite(site.id)} className={classes.configIcon}>
                                                        <RefreshIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <IconButton onClick={() => deleteSite(site.id)} className={classes.configIcon}>
                                                    <DeleteIcon color='red'/>
                                                </IconButton>
                                            </div>
                                        }
                                    </Draggable>
                                )
                                }
                                {provided.placeholder}
                            </div>
                        }
                    </Droppable>
                </DragDropContext>
            </div>
        </Collapse>
        {renderDialogColorPicker()}
    </div>;
};

ManageSliderSheet.propTypes = {
    activeModule: PropTypes.bool,
    config: PropTypes.object,
    setActiveModule: PropTypes.func,
    setConfig: PropTypes.func,
    sites: PropTypes.array
};

export default ManageSliderSheet;
